<div class="flex flex-col">
  <div class="flex flex-col-reverse w-full relative">
    <input
      class="pr-8"
      [id]="id"
      [disabled]="disabled"
      [placeholder]="placeholder"
      [required]="invalid || (required && touched)"
      [attr.pattern]="invalid ? 'SAG_INVALID_STATE' : null"
      [value]="displayValue"
      [attr.aria-label]="ariaLabel"
      [attr.aria-labelledby]="ariaLabelledby || id"
      [attr.aria-describedby]="ariaDescribedby"
      (input)="handleInput($event)"
      (change)="handleChange()"
      (focus)="onFocus()"
      (blur)="onBlur()"
      (keydown)="keydown.emit($event)"
      (keyup)="keyup.emit($event)"
      (mouseenter)="mouseenter.emit($event)"
      (mouseleave)="mouseleave.emit($event)"
      type="text"
      sag-ui-input
      #input
    />
    <label [htmlFor]="id" sag-ui-input-label>
      @if (required) {
        <span>*</span>
      }
      {{ label }}
      @if (hint) {
        <span
          class="text-[#999999] dark:text-[#666666] icon-circle-information pl-2"
          [tooltip]="hint"
          sag-ui-tooltip
        ></span>
      }
    </label>
    @if (loading) {
      <sag-ui-spinner
        class="absolute right-4 top-[37px]"
        size="sm"
      ></sag-ui-spinner>
    } @else {
      <span
        class="absolute right-4 bottom-[0.8rem] z-20 text-black dark:text-white"
        [class.icon-chevron-up]="isOpen"
        [class.icon-chevron-down]="!isOpen"
        [class.opacity-50]="disabled"
        (click)="!disabled && togglePopover($event)"
      ></span>
    }
    <div
      [class]="popoverClasses"
      [class.hidden]="!isOpen"
      (scroll)="onScroll($event)"
      style="max-height: 200px; overflow-y: auto"
    >
      @for (option of options; track option.value) {
        <sag-ui-remote-autocomplete-option
          class="autocomplete-option"
          (click)="handleOptionSelect([option.label, option.value])"
        >
          {{ option.label }}
        </sag-ui-remote-autocomplete-option>
      }
    </div>
  </div>
  @if (error && isArray(error)) {
    <div class="flex flex-col gap-1">
      @for (err of error; track err) {
        <span sag-ui-input-error>{{ err }}</span>
      }
    </div>
  } @else {
    <span sag-ui-input-error>{{ error }}</span>
  }
</div>
